import assert from 'assert-ts';
import type {ManifestationDesignator} from 'types';
import type {RootState} from 'store/types';
import {useAppSelector} from 'store/hooks';

const useIdSelector =
  (designator: ManifestationDesignator | undefined) => (state: RootState) => {
    if (!designator) return undefined;

    const id = state.metadataEdit?.savedMetadata?.manifestations.find(
      m =>
        (designator.type === 'id' && m.id === designator.id) ||
        (designator.type === 'isbn' && m.isbn === designator.id) ||
        (designator.type === 'ean' && m.ean === designator.id),
    )?.id;

    if (!id) {
      assert.soft(
        false,
        'useManifestationIdByDesignators: no manifestation found',
        designator,
      );
    }

    return id;
  };

export const useManifestationIdByDesignators = (
  designator: ManifestationDesignator | undefined,
): string | undefined => {
  const selector = useIdSelector(designator);
  return useAppSelector(selector);
};
